<template>
  <div class="statisticsList">
    <div class="mb-10" style="height: 30px">
      <el-button @click="addRole" type="primary" style="float: right">添加角色</el-button>
    </div>
    <div class="roleBox flex">
      <div class="leftBox">
        <el-input
            type="text"
            v-model.trim="keyword"
            placeholder="请输入角色名称">
          <i slot="suffix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-tree class="mt-10" :data="LefttreeList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div>
      <div class="rightBox">
        <div class="flex">
          <div>
            <div>角色名称：{{ role.name }}</div>
            <div class="mb-10">角色说明：{{ role.note }}</div>
          </div>
          <div style="margin-left: auto">
            <el-button @click="editorRole" plain type="warning">修改角色</el-button>
            <el-button type="danger" plain @click="deleteRole">删除角色</el-button>
          </div>
        </div>
        <div style="border: 1px solid #c9cdd6">
          <el-table
              :header-cell-style="{background:'#F5F5F5'}"
              :data="tableData"
              max-height="600"
          >
            <el-table-column
                prop="userName"
                label="用户名"
                min-width="80">
            </el-table-column>
            <el-table-column
                prop="name"
                label="姓名"
                align="center">
            </el-table-column>
            <el-table-column
                prop="gender"
                align="center"
                label="性别">
            </el-table-column>
            <el-table-column
                prop="workNumber"
                align="center"
                label="工号">
            </el-table-column>
            <el-table-column
                prop="sex"
                align="center"
                label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.deleteFlag" style="color:#F56C6C">禁用</span>
                <span v-else>启用</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="address"
                fixed="right"
                align="center"
                label="操作">
              <template slot-scope="scope">
                <el-button v-if="!scope.row.deleteFlag" @click="remove(scope.row.id,true)" type="text" size="small">移除
                </el-button>
                <el-button v-else @click="remove(scope.row.id,false)" type="text" size="small">启用</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div style="margin-top: 20px">
          <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                      @handleCurrentChange='handleCurrentChange'></Pagination>
        </div>
      </div>
    </div>
    <el-dialog
        :title="dialogTitle"
        :close-on-click-modal="false"
        :visible.sync="addRoleModel"
        width="800px">
      <div class="flex">
        <div>
          <el-form class="mt-20" :model="roleForm" :rules="rules" ref="roleForm" label-width="100px">
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="roleForm.name" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="角色说明">
              <el-input v-model="roleForm.note" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="上级角色">
              <SelectTree
                  :props="props"
                  :options="treeSelectlist"
                  :value="roleForm.valueId"
                  :clearable="isClearable"
                  :accordion="isAccordion"
                  @getValue="getValue($event)"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="pl-10">
          <div>菜单及功能权限配置</div>
          <el-tree class="pt-10" :data="funTree" :props="funTreeProps" node-key="code" ref="funTree"
                   show-checkbox></el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
     <el-button type="primary" @click="submitForm('roleForm')">保存</el-button>
     <el-button @click="addRoleModel = false">关 闭</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import SelectTree from "@/components/treeSelect.vue";
import {cloneDeep} from "lodash";

export default {
  name: "statisticsList",
  data() {
    return {
      keyword: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      tableData: [],
      addRoleModel: false,
      dialogTitle: '添加角色',
      roleForm: {
        name: '',
        parent: '',
        note: '',
        defualtPrivilege: [],
        valueId: null, // 初始ID（可选）
      },
      rules: {
        name: [
          {required: true, message: '请输入角色名称', trigger: 'blur'}
        ],
      },
      funTree: [],
      defaultProps: {
        value: 'id',             // ID字段名
        label: 'name',         // 显示名称
        children: 'children'    // 子级字段名
      },
      funTreeProps: {
        value: 'code',             // ID字段名
        label: 'name',
        disabled:'isClose',// 显示名称
        children: 'children'    // 子级字段名
      },
      isClearable: true, // 可清空（可选）
      isAccordion: true, // 可收起（可选）
      props: {
        // 配置项（必选）
        value: "id",
        label: "name",
        children: "children"
        // disabled:true
      },
      // 选项列表（必选）
      treeSelectlist: [],
      LefttreeList: [],
      userJson: [],
      role: {
        name: '',
        note: ''
      }
    }
  },
  components: {
    //someComponent
    Pagination,
    SelectTree
  },
  created() {
    this.userJson = window.utils.storage.getter('userJson')
  },
  methods: {
    handleNodeClick(a, b, c) {
      this.role = a
      let data = {
        roleId: this.role.id,
        pharmacyId: this.role.pharmacyId,
        page: '1',
        pageSize: '200'
      }
      this.axios
          .get("api/User", {params: data}).then((res) => {
        this.tableData = res.list
        this.tableData.forEach(item => {
          switch (item.gender) {
            case 1:
              item.gender = '男'
              break;
            case 2:
              item.gender = '女'
              break;
            default :
              item.gender = '未知'
          }
        })
      })
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    // 取值
    getValue(value) {
      this.roleForm.valueId = value;
    },
    addRole() { // 添加角色
      this.roleForm = {
        name: '',
        parent: '',
        note: '',
        defualtPrivilege: [],
        valueId: null, // 初始ID（可选）
      },
       this.dialogTitle = '添加角色'
      this.addRoleModel = true
      // if (this.role.defualtPrivilege.length > 0) {
      //   this.defaultKeys = JSON.parse(this.role.defualtPrivilege)
      //   this.$nextTick(() => {
      //     this.$refs.funTree.setCheckedKeys(this.defaultKeys);
      //   })
      // }
    },
    editorRole() {
      this.dialogTitle = '修改角色'
      if(!this.role.id){
        this.$message.error('请选择对应的角色进行修改！！！');
        return
      }
      this.roleForm = {
        name: this.role.name,
        note: this.role.note,
        valueId: this.role.parent, // 初始ID（可选）
        defualtPrivilege: []
      }
      this.addRoleModel = true
      let defualtPrivilege=JSON.parse(this.role.defaultPrivilege)
      if (defualtPrivilege.length > 0) {
        this.defaultKeys = defualtPrivilege
        this.$nextTick(() => {
          this.$refs.funTree.setCheckedKeys(this.defaultKeys);
        })
      }
    },
    deleteRole() { //移除角色
      let data = {
        id: this.role.id,
      }
      this.axios
            .delete("api/Role", {params: data}).then((res) => {
        this.roleList()
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      })
    },
    remove(i, state) {
      let data = {
        id: i,
        lockIt: state,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
            .delete("api/User/lock", {params: data}).then((res) => {
        this.handleNodeClick(this.role)
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.total = res.count
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getCheckedNodes()
          if (this.roleForm.defualtPrivilege.length < 1) {
            this.$message({
              message: '请选择功能权限',
              type: 'warning'
            });
            return
          }
          let data = {}
          if (this.dialogTitle === '修改角色') {
            data = {
              parent: this.roleForm.valueId ? this.roleForm.valueId : null,
              name: this.roleForm.name,
              note: this.roleForm.note,
              defaultPrivilege: this.roleForm.defualtPrivilege,
              operatorId: this.role.operatorId,
              pharmacyId: this.role.pharmacyId
            }
            this.axios
                .put("api/Role?id=" + this.role.id, data).then((res) => {
              this.addRoleModel = false
              this.$nextTick(() => {
                this.$refs.funTree.setCheckedKeys([]);
              })
              this.roleList()
              this.$message({
                message: '操作成功',
                type: 'success'
              });
            })
          } else {
            data = {
              parent: this.roleForm.valueId ? this.roleForm.valueId : null,
              name: this.roleForm.name,
              note: this.roleForm.note,
              defaultPrivilege: this.roleForm.defualtPrivilege,
              operatorId: this.userJson.operatorId,
              pharmacyId: this.userJson.pharmacyId
            }
            this.axios
                 .post("api/Role/PlatForm", data).then((res) => {
              this.addRoleModel = false
              this.$nextTick(() => {
                this.$refs.funTree.setCheckedKeys([]);
              })
              this.roleList()
              this.$message({
                message: '操作成功',
                type: 'success'
              });
            })
          }
        } else {
          return false;
        }
      });
    },
    // list
    init() {
      this.handleNodeClick(this.role)
    },
    // 获取角色权限
    functionAll() {
      let data={
        groupId:'0'
      }
      this.axios.get("api/GroupPrivilege/GetFunctionTree",{params: data}).then((res) => {
        // let treeList = this.getFunctionTree(res.list, 'code');
        this.funTree = res.list
      })
    },
    // getFunctionTree(treeList, key) {
    //   let parentList = []
    //   let sonList = []
    //   treeList.forEach(item => {
    //     if (item.name) {
    //       item.label = item.name;
    //       delete item.name
    //     }
    //     if (item.parent === null) {
    //       item.children = []
    //       parentList.push(item)
    //     } else {
    //       item.children = []
    //       sonList.push(item)
    //     }
    //   })
    //   parentList.forEach(res => {
    //     this.getSonNote(res, sonList, key)
    //   })
    //   return parentList
    // },
    // getSonNote(a, sonList, key) {
    //   sonList.forEach(item => {
    //     if (a[key] === item.parent) {
    //       a.children.push(item)
    //     }
    //     if (a.children.length > 0) {
    //       a.children.forEach(item1 => {
    //         item1.children = []
    //         this.getSonNote(item1, sonList)
    //       })
    //     }
    //   })
    // },
    getCheckedNodes() {
      let data = this.$refs.funTree.getCheckedNodes()
      var privileges=[]
      for (let i in data) {
        privileges.push(data[i].code)
      }
      this.roleForm.defualtPrivilege = JSON.stringify(privileges)
    },
    //获取角色列表
    roleList() {
      this.axios
          .get("api/Role/GetRollTree").then((res) => {
        this.LefttreeList = cloneDeep(res)
        this.treeSelectlist = cloneDeep(res)
      })
    },
  },
  mounted() {
    //
    this.roleList()
    this.functionAll()
  }
}
</script>

<style lang="scss" scoped>
.statisticsList {
  .roleBox {
    width: 100%;
    min-height: 700px;
    border: 1px solid #c9cdd6;

    .leftBox {
      border-right: 1px solid #c9cdd6;
      padding: 20px 30px;
    }

    .rightBox {
      width: 100%;
      padding: 20px 30px;
    }
  }
}
</style>